import SmallDevicePostView from './PostViews/SmallDevicePostView';
import MdXxlPostView from './PostViews/MdXxlPostView';

interface User {
  username: string;
  avatar_url: string;
  verified: boolean;
}

interface Comment {
  id: string;
  content: string;
  created_at: string;
  users?: {
    username: string;
    avatar_url: string;
    verified: boolean;
  };
  content_id: string;
  impressions: number;
  updated_at: string;
  is_pinned?: boolean;
  is_ad: boolean;
}

interface Post {
  id: string;
  caption?: string;
  media_url: string;
  media_type?: 'image' | 'video' | 'music';
  additional_media_urls?: string[];
  music_info?: {
    title: string;
    artist: string;
    coverArt: string;
    duration: number;
  };
  created_at: string;
  users: User;
  likes_count: number;
  comments_count: number;
  bookmarks_count: number;
  gifts_count: number;
  views_count: number;
  comments: Comment[];
}

interface PostViewProps {
  post: Post;
  isOpen: boolean;
  onClose?: () => void;
  initialMediaIndex?: number;
}

export default function PostView({ post, isOpen, onClose, initialMediaIndex = 0 }: PostViewProps) {
  
  if (!isOpen) return null;
  
  // Render the appropriate component based on screen size
  return (
    <>
      {/* Small device view (visible on small screens only) */}
      <div className="md:hidden">
        <SmallDevicePostView post={post} isOpen={isOpen} onClose={onClose} initialMediaIndex={initialMediaIndex} />
      </div>
      
      {/* Medium to XXL device view (visible on md screens and up) */}
      <div className="hidden md:block">
        <MdXxlPostView post={post} isOpen={isOpen} onClose={onClose} initialMediaIndex={initialMediaIndex} />
      </div>
    </>
  );
}
